"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _angieslistReactComponents = require("angieslist-react-components");
var _ratingUtils = _interopRequireDefault(require("./utils/ratingUtils"));
var _certifiedPopOver = _interopRequireDefault(require("./certifiedPopOver"));
var couponOfferIcon = require('./assets/al-coupon-offer.svg');
var distanceIcon = require('./assets/al-distance-icon.svg');
var ssaIcon = require('./assets/al-ssa-icon.png');
var approvedIcon = require('./assets/al-approved-icon.svg');
var FeaturedIcons = function FeaturedIcons(_ref) {
  var _context;
  var postalCode = _ref.postalCode,
    awards = _ref.awards,
    starRating = _ref.starRating,
    ratings = _ref.ratings,
    listedSinceYear = _ref.listedSinceYear,
    customClass = _ref.customClass,
    singleFeaturedPro = _ref.singleFeaturedPro;
  var ssaPopOver = function ssaPopOver() {
    return /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Popover, {
      id: "featured-ssa-popover"
    }, 'A ', /*#__PURE__*/_react["default"].createElement("strong", null, "Super Service Award"), ' goes to providers who have achieved and maintained a superior service rating on Angi.');
  };
  var getSsaImage = function getSsaImage() {
    if (awards.length === 0) {
      return '';
    }
    var firstAwardImages = awards[0].images || [];
    var xsmallImage = (0, _find["default"])(firstAwardImages).call(firstAwardImages, function (image) {
      return image.size === 'x-small';
    });
    if (xsmallImage) {
      return xsmallImage.url;
    }
    return ssaIcon;
  };
  var maybeStarRatingAccolade = (0, _ratingUtils["default"])(ratings);
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "featured-icons",
    className: customClass
  }, !singleFeaturedPro ? [/*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: '5px'
    },
    key: "0"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "featured-icon",
    alt: "Offers Coupon",
    src: couponOfferIcon
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "featured-icon-text"
  }, "Offers Coupon")), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: '5px'
    },
    key: "1"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "featured-icon",
    alt: "Serves ".concat(postalCode),
    src: distanceIcon
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "featured-icon-text"
  }, "Serves ".concat(postalCode)))] : [/*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/_react["default"].createElement(_certifiedPopOver["default"], null),
    key: "0"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "right-accolade"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "featured-icon",
    src: approvedIcon,
    alt: "angi certified"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "featured-icon-text"
  }, "Angi Certified"))), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: '5px'
    },
    key: "1"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "featured-icon",
    alt: "Offers Coupon",
    src: couponOfferIcon
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "featured-icon-text"
  }, "Offers Coupon"))], awards.length > 0 ? /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.OverlayTrigger, {
    placement: "bottom",
    overlay: ssaPopOver()
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "right-accolade"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "featured-icon",
    src: getSsaImage(),
    alt: "Super Service Award"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "featured-icon-text"
  }, "Super Service Award"))) : maybeStarRatingAccolade ? /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      textAlign: 'left'
    }
  }, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.RatingDisplaySingleStar, {
    rating: starRating,
    roundRating: true,
    showRating: false,
    starSize: "1em"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontSize: '14px',
      fontWeight: 600,
      marginLeft: '9px',
      marginTop: '3px'
    }
  }, (0, _concat["default"])(_context = "".concat(maybeStarRatingAccolade.starRating, " Star in ")).call(_context, maybeStarRatingAccolade.name))) : /*#__PURE__*/_react["default"].createElement("span", {
    className: "right-accolade"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon icon-calendar featured-icon"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "featured-icon-text"
  }, "Listed Since ".concat(listedSinceYear))));
};
FeaturedIcons.propTypes = {
  postalCode: _propTypes["default"].string.isRequired,
  starRating: _propTypes["default"].number.isRequired,
  awards: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    description: _propTypes["default"].string,
    images: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      size: _propTypes["default"].string,
      url: _propTypes["default"].string
    }))
  })).isRequired,
  ratings: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    starRating: _propTypes["default"].number
  })).isRequired,
  listedSinceYear: _propTypes["default"].string.isRequired,
  customClass: _propTypes["default"].string,
  singleFeaturedPro: _propTypes["default"].bool
};
FeaturedIcons.defaultProps = {
  customClass: 'featured-icons',
  singleFeaturedPro: false
};
var _default = exports["default"] = FeaturedIcons;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-composed-components/lib/featured/featuredIcons.js
// module id = 2871
// module chunks = 25